// Pulled out the types/data we need from the Prisma client to avoid having to import the whole thing.

const secret = Symbol();

const representations = new WeakMap<ObjectEnumValue, string>();

export abstract class ObjectEnumValue {
  constructor(arg?: symbol) {
    if (arg === secret) {
      representations.set(this, `Prisma.${this._getName()}`);
    } else {
      representations.set(this, `new Prisma.${this._getNamespace()}.${this._getName()}()`);
    }
  }

  abstract _getNamespace(): string;

  _getName() {
    return this.constructor.name;
  }

  toString() {
    return representations.get(this)!;
  }
}

class NullTypesEnumValue extends ObjectEnumValue {
  override _getNamespace() {
    return "NullTypes";
  }
}

class DbNull extends NullTypesEnumValue {}
setClassName(DbNull, "DbNull");

class JsonNull extends NullTypesEnumValue {}
setClassName(JsonNull, "JsonNull");

class AnyNull extends NullTypesEnumValue {}
setClassName(AnyNull, "AnyNull");

export const objectEnumValues = {
  classes: {
    DbNull,
    JsonNull,
    AnyNull,
  },
  instances: {
    DbNull: new DbNull(secret),
    JsonNull: new JsonNull(secret),
    AnyNull: new AnyNull(secret),
  },
};

function setClassName(classObject: Function, name: string) {
  Object.defineProperty(classObject, "name", {
    value: name,
    configurable: true,
  });
}

export namespace Prisma {
  export interface DecimalJsLike {
    d: number[];
    e: number;
    s: number;
    toFixed(): string;
  }

  export type JsonObject = { [Key in string]?: JsonValue };
  export interface JsonArray extends Array<JsonValue> {}
  export type JsonValue = string | number | boolean | JsonObject | JsonArray | null;

  export type InputJsonObject = { readonly [Key in string]?: InputJsonValue | null };
  export interface InputJsonArray extends ReadonlyArray<InputJsonValue | null> {}
  export type InputJsonValue = string | number | boolean | InputJsonObject | InputJsonArray | { toJSON(): unknown };

  export namespace NullTypes {
    export declare class DbNull {
      private DbNull: never;
      private constructor();
    }

    export declare class JsonNull {
      private JsonNull: never;
      private constructor();
    }
  }

  export const DbNull = objectEnumValues.instances.DbNull;
  export const JsonNull = objectEnumValues.instances.JsonNull;
}
